export default __webpack_public_path__ + "static/media/logo-union-black.541ecddd.png";